export default "__VITE_ASSET__nB8QAxaj__"